import { Page } from "@boundary/layouts/pageLayout";
import { Button } from "@boundary/components/button";
import { OnboardingElement } from "@boundary/widgets/onboarding";
import { OnboardingFlowData, OnboardingFlowSteps } from "@boundary/pages/4.onboarding/onboardingFlow";
import { Stepper } from "@boundary/components/stepper";
import styles from "./order.module.scss";

export const OnboardingOrderStep: OnboardingElement<
  OnboardingFlowData,
  OnboardingFlowSteps
> = (props) => {
  return (
    <Page withFog>
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Body className={styles.body}>
          <Stepper count={3} current={2} />
          <h1>Конфигурация услуг</h1>
          <div className={styles.description}>
            <p>После выбора услуги ты можешь настроить её по своему желанию:</p>
            <ul className={styles.list}>
              <li>Добавить необходимое количество файлов для печати</li>
              <li>Настроить тип печати, формат, цвет и многое другое!</li>
            </ul>
          </div>
          <div className={styles.imageContainer}>
            <img
              src="/assets/onboarding/service-onboarding.png"
              className={styles.image}
              alt=""
            />
          </div>
        </Page.DisplayZone.Body>
        <Page.DisplayZone.Sticky className={styles.buttonPad}>
          <Button onClick={() => props.onComplete("pickup")}>Далее</Button>
        </Page.DisplayZone.Sticky>
      </Page.DisplayZone>
    </Page>
  );
};
